import React from 'react'

const PrivacyPolicy = () => {
  return (
    <div className="text-sm">
      <h1 className="text-lg font-bold">PRIVACY POLICY</h1>
      <div>Last updated July 28, 2022</div>

      <div className="my-3">
        This privacy policy (the "Privacy Policy" or "Policy") of our company
        ("Company," "we," "us," or "our") describes our privacy practices
        regarding personal information we collect, including from persons ("you"
        or "your") who access our property’s Resident Portal website (the
        "Site").
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">PURPOSE.</span>
        The purpose of this Privacy Policy is to inform you about the types of
        personal information we gather about you, including personal information
        gathered when you visit the Site, and personal information we may
        receive from third parties or affiliates in addition to that online
        information, how we may use that information, whether we disclose that
        information to anyone, and the choices you have regarding our use of,
        and your ability to correct, the information. This Policy does not cover
        information that is exempted from privacy policy notification
        requirements, including information about employees, contractors, job
        applicants and information processed exclusively in the context of a
        businessperson acting in a business capacity.
      </div>

      <div className="my-3">
        THE SITE IS NOT INTENDED FOR CHILDREN AND COMPANY DOES NOT KNOWINGLY
        SOLICIT OR COLLECT PERSONAL INFORMATION ON THE SITE FROM CHILDREN UNDER
        THE AGE OF 13. IF COMPANY LEARNS THAT A CHILD UNDER THE AGE OF 13 HAS
        SUBMITTED PERSONALLY IDENTIFIABLE INFORMATION TO COMPANY THROUGH THE
        SITE, IT WILL TAKE REASONABLE MEASURES TO DELETE SUCH INFORMATION FROM
        ITS RECORDS AND TO NOT USE SUCH INFORMATION FOR ANY PURPOSE (EXCEPT
        WHERE NECESSARY TO PROTECT THE SAFETY OF THE CHILD OR OTHERS, AS
        REQUIRED BY LAW, OR AS MAY OTHERWISE BE REQUIRED BY LAW).
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">YOUR CONSENT AND POLICY CHANGES.</span>
        PLEASE READ THIS ENTIRE PRIVACY POLICY CAREFULLY. BY USING THE SITE, YOU
        EXPRESSLY CONSENT, WITHOUT QUALIFICATION, TO THE COLLECTION, USE AND
        DISCLOSURE OF INFORMATION, INCLUDING PERSONAL INFORMATION, AS DESCRIBED
        IN THIS PRIVACY POLICY. IF YOU DO NOT AGREE TO THE TERMS OF THIS PRIVACY
        POLICY, YOU ARE NOT AUTHORIZED TO USE THE SITE.
      </div>

      <div className="my-3">
        Company may amend this Privacy Policy from time to time. We will post
        those changes on the website or update the Privacy Policy date below. In
        certain cases, you will be notified via email or by a notice on our
        website.
      </div>

      <h2 className="font-bold my-3">
        PERSONAL INFORMATION COLLECTED IN THE PAST 12 MONTHS
      </h2>

      <div className="my-3">
        We collect, process and store various types of Personal Information. For
        purposes of this Policy, "Personal Information" means information that
        identifies, relates to, describes, is reasonably capable of being
        associated with, or could reasonably be linked, directly or indirectly,
        with a particular consumer or household. It does not include
        de-identified or aggregate information, or public information lawfully
        available from governmental records.
      </div>

      <div className="my-3">
        Personal Information we collect may include: your name, email addresses,
        postal addresses, postal codes, user Internet Protocol (IP) addresses,
        social security/insurance number, driver’s license number, prior
        addresses, monthly rent paid at prior residences, employers, job titles,
        income, telephone numbers, credit card information, bank account
        information and routing numbers, date of birth, gender, age, marital
        status, user name and password (if you choose to become a registered
        user of the Site or our products and services), emergency contact
        information, information about your pets, information about your
        vehicles including license plate numbers, and other information either
        desirable or necessary to provide quality services to our residents and
        visitors. We may also collect information about you such as your use of
        the Site and communication preferences.
      </div>

      <div className="my-3">
        We do not and will not sell your Personal Information.
      </div>

      <div className="my-3">
        Additional Information about How We Collect and Share your Personal
        Information
      </div>

      <div className="my-3">
        With respect to each of the categories of data above, we may also
        collect and share Personal Information with third parties to comply with
        legal obligations; when we believe in good faith that an applicable law
        requires it; at the request of governmental authorities or other third
        parties conducting an investigation; to detect and protect against
        fraud, or any technical or security vulnerabilities; to respond to an
        emergency; or otherwise to protect the rights, property, safety, or
        security of our business, third parties, visitors to our websites and
        mobile apps, or the public. We may also share Personal Information with
        any person to whom we transfer any of our rights or obligations under
        any agreement, or in connection with a sale, merger or consolidation of
        our business or other transfer of our assets, whether voluntarily or by
        operation of law, or who is otherwise deemed to be our successor or
        transferee.
      </div>

      <h2 className="font-bold my-3">
        PERSONAL INFORMATION WE WILL CONTINUE TO COLLECT
      </h2>

      <div className="my-3">
        We will continue to collect the same categories of Personal Information
        listed above, for the same purposes.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">
          USE OF COOKIES AND OTHER TECHNOLOGIES.
        </span>
        Like many other website operators, Company may use cookies to customize
        content specific to your interests and track your use of the Site.
        "Cookies" are text files that are placed on your computer and may be
        used to store your personal information. In addition to cookies, Company
        may use other now known or later developed technologies, to assist
        Company in observing the behavior of users visiting the Site. These
        technologies access individual user information but the information is
        used only to compile aggregated statistics about the Site’s usage.
      </div>

      <div className="my-3">
        Our service providers may use cookies and those cookies may be stored on
        your computer when you visit our website.
      </div>

      <div className="my-3">
        This Site uses Lead Attribution or Marketing Attribution to assess the
        conversions of different channels that generate leads.
      </div>

      <div className="my-3">
        This Site uses Google Analytics (and in the future may use other similar
        sites or services), a web analytics service provided by Google, Inc.
        ("Google"), to better assist Company in understanding how the Site is
        used. Google Analytics will place cookies on your computer that will
        generate information that we select about your use of the Site,
        including your computer’s IP address. That information will be
        transmitted to and stored by Google. The information will be used for
        the purpose of evaluating consumer use of the Site, compiling reports on
        Site activity for Company’s use, and providing other services relating
        to Site activity and usage. Google may also transfer this information to
        third parties where required to do so by law, or where such third
        parties process the information on Google’s behalf. The use of cookies
        by Google Analytics is covered by Google’s privacy policy:
        <a
          href="https://www.google.com/policies/privacy/"
          className="link link-primary mx-1"
          target="_blank"
        >
          https://www.google.com/policies/privacy/
        </a>
        .
      </div>

      <div className="my-3">
        You can choose to delete existing cookies, allow or block cookies, and
        set preferences for certain websites in your browser’s settings. Please
        note you may not be able to use the full functionality of the Site if
        you choose to block all cookies.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">EMAIL AND TEXT MANAGEMENT.</span>
        You may receive emails and texts from Company for a variety of reasons.
        We respect your desire to manage email and text correspondence. If you
        have an account with Company on the Site, you can select your
        preferences through your account settings. You can also manage your
        receipt of certain types of communication by following the instructions
        included in the email we send you. Please note that, even if you
        unsubscribe from certain email correspondences, we may still need to
        email you with information relating to your unit, the management of the
        property, and other important transactional or administrative
        information.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">THIRD-PARTY WEBSITES.</span>
        This Privacy Policy applies solely to information collected by Company.
        This Privacy Policy does not apply to other websites that are accessible
        through this Site, including but not limited to any third-party
        websites.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">
          ACCESSING, REVIEWING AND CHANGING YOUR CONTACT INFORMATION.
        </span>
        As an account holder, you can see, review and change most of your
        contact information associated with your Account Profile by logging into
        your account and editing your Account Profile. For assistance, you may
        contact us using one of the methods listed below. With some exceptions,
        you have the right to see what Personal Information we hold about you.
        We can help you identify what records we might have about you. We may
        need to confirm your identity before providing you with this access, and
        if we cannot verify your identity with the degree of certainty required,
        we will not be able to respond to your request. If we cannot give you
        access, we will tell you within 45 days of receipt of your request and
        provide you with a reason, as best we can, as to why we cannot give you
        access.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">PERSONAL INFORMATION OF MINORS.</span>
        Our Sites are not directed to minors under the age of 16 and we do not
        knowingly collect Personal Information from minors. We may collect
        Personal Information of minors, provided by parents or guardians, in
        connection with the application and rental of a unit, or the provision
        of property management services. We do not sell the Personal Information
        of minors.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">CALIFORNIA RESIDENTS’ RIGHTS.</span>
        The California Consumer Privacy Act (CCPA) may apply to California
        residents whose Personal Information is collected by landlords of a
        certain size or that meet other criteria. If the CCPA applies to us,
        California residents may request to know about Personal Information
        collected about them and request deletion of that Personal Information.
        These rights are subject to certain exceptions, including without
        limitation, for Personal Information subject to the Fair Credit
        Reporting Act and the Gramm-Leach-Bliley Act. If we are subject to the
        CCPA, you can learn more about these rights and our processes for
        consumer requests by contacting us using one of the methods listed
        below. If you exercise any of the rights afforded to you by the CCPA, we
        will continue to treat you fairly.
      </div>

      <h2 className="font-bold italic my-3">
        Right to request disclosure of information we have collected about you
      </h2>

      <div className="my-3">
        If the CCPA applies to us and to your information, you can submit a
        request to us for the following personal information we have collected:
        <ul className="list-disc ml-6">
          <li>
            The categories of personal information we’ve collected about you.
          </li>
          <li>
            The categories of sources from which we collected the personal
            information.
          </li>
          <li>
            The business or commercial purposes for which we collected or sold
            the personal information.
          </li>
          <li>
            The categories of third parties with which we shared the personal
            information.
          </li>
          <li>
            The specific pieces of personal information we collected about you.
          </li>
          <li>
            The categories of personal information (if any) that we have sold
            about you, the categories of third parties to which we sold that
            information, and the category or categories of personal information
            sold to each third party.
          </li>
          <li>
            The categories of personal information that we disclosed about you
            for a business purpose.
          </li>
        </ul>
      </div>

      <div className="my-3">
        Our responses to any of these requests will cover the 12-month period
        preceding our receipt of the request.
      </div>

      <h2 className="font-bold italic my-3">
        Right to request the deletion of personal information we have collected
        from you
      </h2>

      <div className="my-3">
        Upon request, we will delete the personal information we have collected
        about you that is covered by the CCPA, unless a relevant exception to
        the right to deletion applies.
      </div>

      <h2 className="font-bold italic my-3">Do Not Track</h2>

      <div className="my-3">
        "Do Not Track" is a privacy preference that users can set in certain web
        browsers. We do not respond to browser or do not track signals.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">ACCESSIBILITY.</span>
        We are committed to ensuring that our communications are accessible to
        people with disabilities. To make accessibility-related requests or
        report barriers, please contact us using one of the methods below.
      </div>

      <h2 className="font-bold italic my-3">CONTACTING US.</h2>

      <div className="my-3">
        If you have questions regarding this Privacy policy or use of
        information collected, please contact your property manager using the
        Contact Us form.
      </div>

      <div className="my-3">Updated: July 28, 2022</div>
    </div>
  )
}

export default PrivacyPolicy
